/**
 *@author zcc
 *@date 2022/3/7 17:11
 */
import { UrlConfig } from '@/config/UrlConfig';
export class AuditLogUrlConfig {
  public static auditLogList = `${UrlConfig.websiteBaseurl}/audit/log/list`;

  public static saveAuditLog = `${UrlConfig.websiteBaseurl}/audit/log`;
}
